import { render, staticRenderFns } from "./render-events.vue?vue&type=template&id=673800fd&"
import script from "./render-events.vue?vue&type=script&lang=ts&"
export * from "./render-events.vue?vue&type=script&lang=ts&"
import style0 from "./render-events.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports